import React from "react"
import BrandResearch from "../components/brand/BrandResearch";

const Brand: React.FC = () => {
    return (
        <BrandResearch></BrandResearch>
    )
}

export default Brand;